import React, { useEffect, useState } from 'react'
import axios from 'axios'

function CustomerOrderHistory() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const auth = JSON.parse(localStorage.getItem("auth"));
        const token = auth?.accessToken;
        const res = await axios.get(`${API_BASE}/user/provider/customer-orders`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setOrders(res.data.data);
      } catch (err) {
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Customers Order History</h2>
      {loading ? (
        <div>Loading...</div>
      ) : orders.length === 0 ? (
        <div>No customer orders found.</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Customer</th>
              <th className="p-2 text-left">Service</th>
              <th className="p-2 text-left">Status</th>
                <th className="p-2 text-left">Cancellation Reason</th>
              <th className="p-2 text-left">Date</th>
              <th className="p-2 text-left">Contact</th> {/* ✅ New column */}
            </tr>
          </thead>
          <tbody>
            {orders.map((order, idx) => {
              const customer = order.user;
              const phone = customer?.phoneNumber?.replace(/^0/, "92"); // Convert to international format

              return (
                <tr key={order._id || idx} className="border-b">
                  <td className="p-2">
                    {customer?.firstName} {customer?.lastName}
                    <br />
                    <span className="text-sm text-gray-600">{customer?.email}</span>
                  </td>
                  <td className="p-2">{order.serviceName}</td>
                  <td className="p-2">{order.status}</td>
                  <td className="p-2">
                    {order.cancellationReason ? (
                      <span className="text-red-500">{order.cancellationReason}</span>
                    ) : (
                      <span className="text-gray-400 text-xs">N/A</span>
                    )}
                  </td>
                  <td className="p-2">{new Date(order.createdAt).toLocaleString()}</td>
                  <td className="p-2 flex flex-col gap-2">
                    {phone ? (
                      <a
                        href={`https://wa.me/${phone}?text=${encodeURIComponent(
                          `🧾 *Service Booking Invoice*\n\n` +
                          `🆔 *Order ID:* ${order?._id}\n` +
                          `👤 *Customer:* ${customer?.firstName} ${customer?.lastName}\n` +
                          `📞 *Phone:* ${phone}\n` +
                          `📍 *Address:* ${order?.address}\n` +
                          `🌐 *Map:* ${order?.mapAddress || 'N/A'}\n\n` +
                          `🔧 *Service Details:*\n` +
                          `🔹 *Service:* ${order?.serviceName}\n` +
                          `🏘️ *Area:* ${order?.serviceArea}\n` +
                          `🕒 *Date:* ${new Date(order?.createdAt).toLocaleString()}\n` +
                          `📌 *Status:* ${order?.status}\n\n` +
                          `💰 *Charges:* 200 PKR (Service Fee)\n` +
                          `💳 *Payment Method:* Online \n\n` +
                          `✅ *Note:* Please be available at the location on the scheduled time.\n\n` +
                          `🙏 Thank you for booking with *Service at Door*!`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-green-500 text-white px-3 py-2 rounded-md text-sm hover:bg-green-600"
                      >
                        Send Invoice via WhatsApp
                      </a>
                    ) : (
                      <span className="text-gray-400 text-xs">No Phone</span>
                    )}

                    {/* Send Invoice via Email */}
                    {customer?.email && (
                      <a
                        href={`mailto:${customer.email}?subject=${encodeURIComponent(
                          "Your Service Booking Invoice"
                        )}&body=${encodeURIComponent(
                          `🧾 Service Booking Invoice\n\n` +
                          `Order ID: ${order?._id}\n` +
                          `Customer: ${customer?.firstName} ${customer?.lastName}\n` +
                          `Phone: ${phone}\n` +
                          `Address: ${order?.address}\n` +
                          `Map: ${order?.mapAddress || 'N/A'}\n\n` +
                          `Service Details:\n` +
                          `Service: ${order?.serviceName}\n` +
                          `Area: ${order?.serviceArea}\n` +
                          `Date: ${new Date(order?.createdAt).toLocaleString()}\n` +
                          `Status: ${order?.status}\n\n` +
                          `Charges: 200 PKR (Service Fee)\n` +
                          `Payment Method: Online\n\n` +
                          `Note: Please be available at the location on the scheduled time.\n\n` +
                          `Thank you for booking with Service at Door!`
                        )}`}
                        className="bg-blue-500 text-white px-3 py-2 rounded-md text-sm hover:bg-blue-600 mt-1"
                      >
                        Send Invoice via Email
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

      )}
    </div>
  )
}

export default CustomerOrderHistory